import React, { useState } from 'react';
import ReportForm from './ReportForm';
import { type ReportFormData } from './types';

/**
 * Modal component for creating a new report
 */
type CreateReportModalProps = {
  onSave: (data: ReportFormData) => void | Promise<void>;
  onCancel?: () => void;
};

export default function CreateReportModal({
  onSave,
  onCancel,
}: CreateReportModalProps) {
  const [isCreating, setIsCreating] = useState(false);
  return (
    <div className="cn-edit-modal-overlay">
      <div className="cn-edit-modal-content">
        <h2 className="cn-edit-modal-title">Create New Impact Report</h2>
        {/*<p className="cn-edit-modal-description">
          Enter the program name and year for your new report.
        </p>*/}
        <ReportForm
          initialData={null}
          onSubmit={async (data: ReportFormData) => {
            setIsCreating(true);
            await onSave(data);
            setIsCreating(false);
          }}
          onCancel={onCancel}
          submitLabel="Create Report"
          isLoading={isCreating}
        />
      </div>
    </div>
  );
}
